var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicBackupCodesmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 163,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.774 95.265c.151 0 .3.007.451.01v-.01c0-13.072 10.794-23.668 24.11-23.668 10.813 0 19.963 6.988 23.02 16.614a16.778 16.778 0 0 1 7.726-1.872c9.171 0 16.605 7.298 16.605 16.301 0 1.467-.2 2.887-.57 4.239a13.578 13.578 0 0 1 5.446-1.139c7.421 0 13.438 5.907 13.438 13.192 0 7.286-6.017 13.192-13.438 13.192H50.774c-10.368 0-18.774-8.251-18.774-18.43 0-10.178 8.406-18.43 18.774-18.43Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.743 46.264c-.147 0-.293.008-.439.011v-.011c0-12.857-10.497-23.28-23.446-23.28-10.515 0-19.414 6.874-22.387 16.342a16.169 16.169 0 0 0-7.513-1.841c-8.918 0-16.148 7.178-16.148 16.034 0 1.442.195 2.839.554 4.169a13.087 13.087 0 0 0-5.296-1.12c-7.217 0-13.068 5.81-13.068 12.976 0 7.166 5.851 12.975 13.068 12.975h74.675c10.083 0 18.257-8.116 18.257-18.127 0-10.012-8.174-18.128-18.257-18.128Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.851 104.417c.088 0 .174.005.261.007v-.007c0-7.714 6.239-13.967 13.935-13.967 6.249 0 11.538 4.123 13.305 9.805a9.531 9.531 0 0 1 4.465-1.105c5.301 0 9.598 4.307 9.598 9.62 0 .866-.116 1.704-.33 2.502a7.712 7.712 0 0 1 3.148-.672c4.29 0 7.767 3.485 7.767 7.785 0 4.3-3.477 7.786-7.767 7.786h-44.382c-5.993 0-10.851-4.87-10.851-10.877 0-6.007 4.858-10.877 10.851-10.877Z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.403 65.75V40.837H94.824c-3.769 0-6.824 3.014-6.824 6.732v81.792c0 3.718 3.055 6.732 6.824 6.732h61.832c3.769 0 6.824-3.014 6.824-6.732v-56.88h-25.253c-3.769 0-6.824-3.013-6.824-6.731Z",
    fill: "#0090ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.402 40.837V65.75c0 3.718 3.056 6.732 6.824 6.732h25.254c0-3.222-1.297-6.311-3.606-8.589l-19.765-19.498a12.4 12.4 0 0 0-8.707-3.558Z",
    fill: "#00B3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m106.666 110.307.704 3.029h-2.994l.705-3.029-2.34 2.11-1.46-2.581 2.995-.894-2.995-.943 1.535-2.532 2.265 2.11-.705-3.028h2.994l-.729 3.078 2.365-2.16 1.484 2.582-3.094.918 3.094.918-1.534 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m119.9 110.307.705 3.029h-2.994l.704-3.029-2.34 2.11-1.459-2.581 2.994-.894-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.365-2.16 1.485 2.582-3.095.918 3.095.918-1.535 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m133.139 110.307.704 3.029h-2.994l.704-3.029-2.34 2.11-1.459-2.581 2.994-.894-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.366-2.16 1.484 2.582-3.095.918 3.095.918-1.535 2.532-2.289-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m146.377 110.307.704 3.029h-2.994l.705-3.029-2.34 2.11-1.46-2.581 2.994-.894-2.994-.943 1.535-2.532 2.265 2.11-.705-3.028h2.994l-.729 3.078 2.365-2.16 1.484 2.582-3.094.918 3.094.918-1.534 2.532-2.29-2.11ZM106.666 96.656l.704 3.028h-2.994l.705-3.028-2.34 2.11-1.46-2.582 2.995-.893-2.995-.943 1.535-2.532 2.265 2.11-.705-3.028h2.994l-.729 3.078 2.365-2.16 1.484 2.581-3.094.919 3.094.918-1.534 2.532-2.29-2.11ZM119.9 96.656l.705 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.893-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.365-2.16 1.485 2.581-3.095.919 3.095.918-1.535 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m133.139 96.656.704 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.893-2.994-.943 1.535-2.532 2.264 2.11-.704-3.028h2.994l-.73 3.078 2.366-2.16 1.484 2.581-3.095.919 3.095.918-1.535 2.532-2.289-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-1000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m146.377 96.656.704 3.028h-2.994l.705-3.028-2.34 2.11-1.46-2.582 2.994-.893-2.994-.943 1.535-2.532 2.265 2.11-.705-3.028h2.994l-.729 3.078 2.365-2.16 1.484 2.581-3.094.919 3.094.918-1.534 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m106.666 83.005.704 3.028h-2.994l.705-3.028-2.34 2.11-1.46-2.582 2.995-.893-2.995-.943 1.535-2.532 2.265 2.11-.705-3.029h2.994l-.729 3.078 2.365-2.16 1.484 2.582-3.094.919 3.094.918-1.534 2.532-2.29-2.11ZM119.9 83.005l.705 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.893-2.994-.943 1.535-2.532 2.264 2.11-.704-3.029h2.994l-.73 3.078 2.365-2.16 1.485 2.582-3.095.919 3.095.918-1.535 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-300"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m133.139 83.005.704 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.893-2.994-.943 1.535-2.532 2.264 2.11-.704-3.029h2.994l-.73 3.078 2.366-2.16 1.484 2.582-3.095.919 3.095.918-1.535 2.532-2.289-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-1000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m146.377 83.005.704 3.028h-2.994l.705-3.028-2.34 2.11-1.46-2.582 2.994-.893-2.994-.943 1.535-2.532 2.265 2.11-.705-3.029h2.994l-.729 3.078 2.365-2.16 1.484 2.582-3.094.919 3.094.918-1.534 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m106.666 69.354.704 3.028h-2.994l.705-3.028-2.34 2.11-1.46-2.582 2.995-.893-2.995-.943 1.535-2.532 2.265 2.11-.705-3.029h2.994l-.729 3.078 2.365-2.16 1.484 2.582-3.094.919 3.094.918-1.534 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in animation-delay-300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m119.9 69.354.705 3.028h-2.994l.704-3.028-2.34 2.11-1.459-2.582 2.994-.893-2.994-.943 1.535-2.532 2.264 2.11-.704-3.029h2.994l-.73 3.078 2.365-2.16 1.485 2.582-3.095.919 3.095.918-1.535 2.532-2.29-2.11Z",
    fill: "#fff",
    className: "animate-fade-out-in"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "animate-spin-xl origin-[5.75rem_7.88rem]"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92,
    cy: 126.171,
    rx: 22,
    ry: 21.829,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.918 117.23a1.48 1.48 0 0 0-2.2.002l-6.89 7.47c-.5.542-.5 1.403 0 1.945l6.89 7.47a1.48 1.48 0 0 0 2.202 0 1.691 1.691 0 0 0 0-2.269l-5.69-6.178 5.698-6.178a1.688 1.688 0 0 0-.01-2.262ZM95.082 117.23a1.48 1.48 0 0 1 2.2.002l6.89 7.47c.5.542.5 1.403 0 1.945l-6.89 7.47a1.48 1.48 0 0 1-2.202 0 1.691 1.691 0 0 1 0-2.269l5.69-6.178-5.698-6.178a1.688 1.688 0 0 1 .01-2.262Z",
    fill: "#E31587",
    stroke: "#E31587"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 37.597,
    width: 173,
    height: 124.527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 81,
    y: -13.016,
    width: 170,
    height: 123.535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11537",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 105,
    y: 60.45,
    width: 127,
    height: 99.721,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5165_11537"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5165_11537",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicBackupCodesmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_backup_codes.min.01395a53dab0c5c5a7420e75250ff660.svg";